/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Partner_Faq_Month_AInputs */



/**
* | output |
* | --- |
* | "To the month its period ends in. A period from 28 July to 28 August is part of the August bills. Because customers start on different days, a month fills up ..." |
*
* @param {Partner_Faq_Month_AInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_faq_month_a = /** @type {((inputs?: Partner_Faq_Month_AInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Faq_Month_AInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Zu dem Monat, in dem ihr Zeitraum endet. Ein Zeitraum vom 28. Juli bis 28. August gehört zu den Abrechnungen für August. Da Kunden an verschiedenen Tagen beginnen, füllt sich ein Monat, während die Zeiträume der Kunden enden; vollständig ist er, wenn der Monat vorbei ist.")
	return /** @type {LocalizedString} */ ("To the month its period ends in. A period from 28 July to 28 August is part of the August bills. Because customers start on different days, a month fills up as each customer's period closes; it is complete once the month is over.")
});